/* [REV] Preços - Ecomhard */
(() => {
  const SELECTOR = '[data-ecomhard-rev-prices]';

  function money(amount, moneyFormat) {
    if (typeof window.formatPrice === 'function') {
      return window.formatPrice(amount, moneyFormat);
    }
    if (typeof formatPrice === 'function') {
      return formatPrice(amount, moneyFormat);
    }

    const value = Number(amount || 0) / 100;
    return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'BRL'
    }).format(value);
  }

  function installmentCount(price, maxInstallments, minInstallmentCents) {
    const max = Math.max(1, parseInt(maxInstallments, 10) || 1);
    const minimum = Math.max(0, parseInt(minInstallmentCents, 10) || 0);

    if (!minimum) return max;

    const byMinimum = Math.max(1, Math.floor(Number(price || 0) / minimum));
    return Math.max(1, Math.min(max, byMinimum));
  }

  function updateContainer(container, variant) {
    if (!container || !variant) return;

    const price = Number(variant.price || 0);
    const compareAtPrice = Number(variant.compare_at_price || 0);
    const pixDiscount = Math.max(0, Number(container.dataset.pixDiscount || 0));
    const installmentsMax = Number(container.dataset.installmentsMax || 1);
    const installmentMinCents = Number(container.dataset.installmentMinCents || 0);
    const moneyFormat = container.dataset.moneyFormat || window.theme?.settings?.money_format || 'R$ {{amount_with_comma_separator}}';

    const baseElement = container.querySelector('[data-ecomhard-base-price]');
    const compareElement = container.querySelector('[data-ecomhard-compare-price]');
    const installmentElement = container.querySelector('[data-ecomhard-installments-count]');
    const pixLine = container.querySelector('[data-ecomhard-line="pix"]');
    const pixElement = container.querySelector('[data-ecomhard-pix-price]');
    const pixTag = container.querySelector('[data-ecomhard-pix-tag]');

    if (baseElement) baseElement.textContent = money(price, moneyFormat);

    if (compareElement) {
      const showCompare = compareAtPrice > price;
      compareElement.classList.toggle('hidden', !showCompare);
      if (showCompare) compareElement.textContent = money(compareAtPrice, moneyFormat);
    }

    if (installmentElement) {
      installmentElement.textContent = installmentCount(price, installmentsMax, installmentMinCents);
    }

    if (pixLine) {
      const showPix = pixDiscount > 0;
      pixLine.classList.toggle('hidden', !showPix);

      if (showPix) {
        const pixPrice = Math.floor(price * ((100 - pixDiscount) / 100));
        if (pixElement) pixElement.textContent = money(pixPrice, moneyFormat);
        if (pixTag) pixTag.textContent = `-${pixDiscount}%`;
      }
    }
  }

  function updatePdp(sectionId, variant) {
    document
      .querySelectorAll(`${SELECTOR}[data-context="pdp"]`)
      .forEach(container => {
        if (String(container.dataset.sectionId) === String(sectionId)) {
          updateContainer(container, variant);
        }
      });
  }

  function getCardVariant(card) {
    if (!card) return null;

    const json = card.querySelector('[data-product-variants-json]');
    if (!json) return null;

    let variants = [];
    try {
      variants = JSON.parse(json.textContent || '[]');
    } catch (error) {
      return null;
    }

    if (!variants.length) return null;

    const optionGroups = [...card.querySelectorAll('.js-product-card-options')];
    const selectedOptions = [];

    optionGroups.forEach(group => {
      const wrapper = group.parentNode;
      const selected = group.querySelector('input[type="radio"]:checked');

      if (wrapper?.classList?.contains('hidden')) {
        const first = group.querySelector('input[type="radio"]');
        if (first) selectedOptions.push(first.value);
      } else if (selected) {
        selectedOptions.push(selected.value);
      }
    });

    if (!selectedOptions.length) {
      const currentId = card.querySelector('input[name="id"]')?.value;
      return variants.find(variant => String(variant.id) === String(currentId)) || variants[0];
    }

    return variants.find(variant => {
      const options = Array.isArray(variant.options) ? variant.options : [];
      return options.length === selectedOptions.length && options.every((option, index) => String(option) === String(selectedOptions[index]));
    }) || variants[0];
  }

  function updateCard(card) {
    const container = card?.querySelector(`${SELECTOR}[data-context="card"]`);
    if (!container) return;

    const variant = getCardVariant(card);
    if (variant) updateContainer(container, variant);
  }

  function initPubSub() {
    if (typeof subscribe !== 'function') return;

    subscribe('variant-change', payload => {
      const data = payload?.data || {};
      if (!data.sectionId || !data.variant) return;
      updatePdp(data.sectionId, data.variant);
    });
  }

  document.addEventListener('click', event => {
    const input = event.target.closest('product-card .variant-option-radio-input');
    if (!input) return;

    const card = input.closest('product-card');
    window.requestAnimationFrame(() => updateCard(card));
  });

  document.addEventListener('change', event => {
    const input = event.target.closest('product-card .variant-option-radio-input');
    if (!input) return;
    updateCard(input.closest('product-card'));
  });

  document.addEventListener('DOMContentLoaded', () => {
    initPubSub();
    document.querySelectorAll('product-card').forEach(updateCard);
  });

  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll?.('product-card').forEach(updateCard);
  });
})();
